import { supabase } from '../lib/supabase';

type ResultadoRespostaBot = {
  resposta: string;
  intencaoId: number;
  intencaoNome: string;
  fraseEncontrada: string;
  score: number;
} | null;

type RpcMatchRow = {
  frase_id: number;
  intencao_id: number;
  frase: string;
  rank_fts: number;
  rank_trgm: number;
  score_final: number;
};

type IntencaoRow = {
  id: number;
  nome: string;
  resposta: string;
};

export async function buscarRespostaBot(
  pergunta: string
): Promise<ResultadoRespostaBot> {
  console.log('🔥 FUNÇÃO DO CHATBOT EXECUTOU');
  console.log('Pergunta recebida:', pergunta);

  const { data: match, error: matchError } = await supabase.rpc(
    'buscar_intencao_chatbot',
    { pergunta }
  );

  console.log('RPC match:', match);
  console.log('RPC error:', matchError);

  const resultados = ((match as RpcMatchRow[] | null) ?? []).filter(Boolean);

  if (matchError || resultados.length === 0) {
    console.log('Nenhum match encontrado');

    return {
      resposta:
        'Não consegui identificar sua dúvida com segurança. Posso te ajudar com seguro empresarial, seguro auto, renovação, redução de custo, análise de seguro ou explicar o Método de Contratação Ativa. Para atendimento direto, fale com um especialista no WhatsApp.',
      intencaoId: 0,
      intencaoNome: 'fallback_sem_match',
      fraseEncontrada: '',
      score: 0,
    };
  }

  const melhor = resultados[0];
  console.log('Melhor match:', melhor);

  if (!melhor || melhor.score_final < 0.08) {
    console.log('Match com baixa confiança');

    return {
      resposta:
        'Ainda não consegui entender sua pergunta com segurança. Você pode perguntar sobre Método de Contratação Ativa, redução do valor do seguro, seguro empresarial, seguro auto, renovação ou análise do seguro. Se preferir, fale agora com um especialista no WhatsApp.',
      intencaoId: 0,
      intencaoNome: 'fallback_baixa_confianca',
      fraseEncontrada: melhor?.frase ?? '',
      score: melhor?.score_final ?? 0,
    };
  }

  const { data: intencao, error: intencaoError } = await supabase
    .from('chatbot_intencoes')
    .select('id, nome, resposta')
    .eq('id', melhor.intencao_id)
    .eq('ativo', true)
    .maybeSingle();

  console.log('Intenção encontrada:', intencao);
  console.log('Erro intenção:', intencaoError);

  if (intencaoError || !intencao) {
    console.log('Intenção não encontrada ou inativa');

    return {
      resposta:
        'Encontrei um tema parecido com sua dúvida, mas não consegui recuperar a resposta correta. Fale com um especialista da IBX Brasil pelo WhatsApp para receber orientação.',
      intencaoId: 0,
      intencaoNome: 'fallback_sem_intencao',
      fraseEncontrada: melhor.frase,
      score: melhor.score_final,
    };
  }

  const linha = intencao as IntencaoRow;

  return {
    resposta: linha.resposta,
    intencaoId: linha.id,
    intencaoNome: linha.nome,
    fraseEncontrada: melhor.frase,
    score: melhor.score_final,
  };
}